import { googleAnalyticsService } from '../../service/google-analytics-service'
import { attributionUtil } from '../../util/attribution-util'

export class GoogleAnalyticsInitiate {
  public get Name(): string {
    return 'Google Analytics'
  }

  protected _destroyFn(): Promise<void> {
    return Promise.resolve(undefined)
  }

  protected async _initFn(): Promise<void> {
    // Snapshot campaign params from the landing URL (first-touch) before any
    // navigation strips them, so GA4 signup events can be attributed.
    attributionUtil.captureLandingParams()
    await googleAnalyticsService.init()
  }
}
